import CardFrontEdit from '~/components/CardMaker/components/CardFrontEdit';
import CardText from '~/components/CardMaker/components/CardFrontEdit/CardText';
import CardArt from '~/components/CardMaker/components/CardFrontEdit/CardArt';
import { useDispatch } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import React from 'react';
import { updateTemplates } from '../../upgradeCardSlice';

export function renderUpgradeCardFrontEdit(name, replacements, templateId, templates) {
    return (tempUrl, setTempUrl, convertedContent, nameColor, frontSides) => {
        const dispatch = useDispatch();

        //display picture dynamically upon selecting template.
        React.useEffect(() => {
            const selected = templates.find((template) => template.id == templateId);

            setTempUrl((prev) => ({
                ...prev,
                cardFrame: selected.cardFrame,
            }));
        }, [templateId]);

        // when uploading new cardBack, update their values in redux so that they can display as preview in next selection.
        React.useEffect(() => {
            let selected = templates.find((item) => item.id == templateId);

            if (selected.cardFrame === tempUrl.cardFrame) return;

            selected = cloneDeep(selected);
            selected.cardFrame = tempUrl.cardFrame;

            dispatch(updateTemplates(selected));
        }, [tempUrl.cardFrame]);

        return (
            <CardFrontEdit
                cardFrame={tempUrl.cardFrame}
                id={frontSides.find((item) => item.includes('.')) || 'cardFrame'}
                replacements={replacements}
                cardArtElement={<CardArt cardArt={tempUrl.cardArt} />}
                cardTextElement={
                    <CardText
                        title={name}
                        description={convertedContent}
                        nameColor={nameColor}
                    />
                }
            />
        );
    };
}
